export const useChatStore = defineStore("chat", () => {
  const pageIndex = ref(-1);

  const changePageIndex = (flag: number) => {
    pageIndex.value = flag;
  };

  const modelIndex = ref(0);

  const changeModelIndex = (index: number) => {
    modelIndex.value = index;
  };

  type TicketStatus = "open" | "closed";

  interface DemoTicket {
    id: string;
    user: string;
    time: string;
    subject: string;
    question: string;
    message: string;
    link: string;
    status: TicketStatus;
    attachments?: string[];
  }

  const formatServiceTime = () =>
    new Intl.DateTimeFormat("en-US", {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
    }).format(new Date());

  const serviceTickets = ref<DemoTicket[]>([
    {
      id: "TCK-1001",
      user: "Marco Support",
      time: formatServiceTime(),
      subject: "Order status",
      question: "Has my order shipped?",
      message: "Your order is being checked by our support team. We will keep all updates in this ticket.",
      link: "View detail",
      status: "open",
    },
  ]);

  const selectedTicket = ref<DemoTicket | null>(serviceTickets.value[0]);

  const createServiceTicket = (payload: {
    category: string;
    subject: string;
    message: string;
    attachments?: string[];
  }) => {
    const ticket: DemoTicket = {
      id: `TCK-${Date.now().toString().slice(-6)}`,
      user: "Marco Support",
      time: formatServiceTime(),
      subject: payload.subject,
      question: payload.category,
      message: payload.message,
      link: "View detail",
      status: "open",
      attachments: payload.attachments,
    };

    serviceTickets.value.unshift(ticket);
    selectedTicket.value = ticket;
    pageIndex.value = 3;
  };

  const selectTicket = (ticket: DemoTicket) => {
    selectedTicket.value = ticket;
  };

  const closeTicket = (ticket: DemoTicket) => {
    ticket.status = "closed";
    selectedTicket.value = ticket;
  };

  return {
    pageIndex,
    changePageIndex,
    modelIndex,
    changeModelIndex,
    serviceTickets,
    selectedTicket,
    createServiceTicket,
    selectTicket,
    closeTicket,
  };
});
